<!-- The menu's card look (same rows, sizes and colours as the item cards in sidenav-item). -->
<div class="vex-user-menu" role="menu" aria-label="Account">
  <!-- Opens the reader's own person panel over the current screen; Cmd/Ctrl-click keeps the
       address's new tab (the old contact page). -->
  <a (click)="openMyProfile($event)" [href]="'/contacts/' + securityService.securityObject.userId"
    class="vex-user-menu-item" role="menuitem">
    <mat-icon class="vex-user-menu-item__icon" svgIcon="mat:account_circle"></mat-icon>
    <div class="vex-user-menu-item__label">My profile</div>
  </a>

  <!-- Planned: in the menu but not built yet — not clickable, the tooltip says why -->
  <div class="vex-user-menu-item vex-user-menu-item--planned" tabindex="0" aria-disabled="true" role="menuitem"
    [matTooltip]="planned.notifications" matTooltipPosition="right">
    <mat-icon class="vex-user-menu-item__icon" svgIcon="mat:notifications"></mat-icon>
    <div class="vex-user-menu-item__label">Notifications</div>
    <div class="vex-user-menu-item__planned">Planned</div>
  </div>

  <div class="vex-user-menu-item vex-user-menu-item--planned" tabindex="0" aria-disabled="true" role="menuitem"
    [matTooltip]="planned.help" matTooltipPosition="right">
    <mat-icon class="vex-user-menu-item__icon" svgIcon="mat:help_outline"></mat-icon>
    <div class="vex-user-menu-item__label">Help &amp; support</div>
    <div class="vex-user-menu-item__planned">Planned</div>
  </div>

  <div class="vex-user-menu-sep" role="separator"></div>

  <div class="vex-user-menu-item" tabindex="0" role="menuitem"
    (click)="toggleConfigPanel()" (keydown.enter)="toggleConfigPanel()">
    <mat-icon class="vex-user-menu-item__icon" svgIcon="mat:invert_colors"></mat-icon>
    <div class="vex-user-menu-item__label">Appearance</div>
  </div>

  <a (click)="logout()" [routerLink]="['/login']" class="vex-user-menu-item" role="menuitem">
    <mat-icon class="vex-user-menu-item__icon" svgIcon="mat:logout"></mat-icon>
    <div class="vex-user-menu-item__label">Sign out</div>
  </a>
</div>
